import {
    fnCookie
} from '@/utils/localStorage'

import {
    getUserInfo
} from '@/utils/auth'
import APP from '@/utils/base'

export function fnUploadObjToText(_uploadObj) {
    if (!_uploadObj) return '未上传'
    _uploadObj = typeof _uploadObj === 'object' ? _uploadObj : JSON.parse(_uploadObj)
    let _arr = []
    let _site = ''
    let _obj = fnCookie('uploadRegion')

    let userInfo = getUserInfo()

    // todo
    if (userInfo.id == 11617) {
        delete _obj.qzy
    }

    for (let _item in _uploadObj) {
        if (_item === 'cdjg_reply') {
            _site = '已上传至成都建工' + '—' + _uploadObj[_item]
            _arr.push(_site)
        } else if (_item === 'upload_cd_date') {
            _site = '已上传至成都市建委' + '—' + _uploadObj[_item]
            _arr.push(_site)
        } else if (_obj[_item]) {

            if (isNaN(Date.parse(_uploadObj[_item]))) {
                _site = _obj[_item] + '—' + _uploadObj[_item]
            } else {
                _site = '已上传至' + _obj[_item] + '—' + _uploadObj[_item]
            }

            _arr.push(_site)
        }
    }
    if (!_arr.length) return '未上传'
    return _arr.join('\n')
}

export function fnCdUploadObjToText(_uploadObj) {
    if (!_uploadObj) return '未上传'
    _uploadObj = typeof _uploadObj === 'object' ? _uploadObj : JSON.parse(_uploadObj)
    let _arr = []
    let _site = ''
    let _obj = {
        cd: '已上传至成都市建委',
        upload_cd_date: '采集时间',
    }
    for (let _item in _uploadObj) {
        if (_obj[_item]) {
            _site = _obj[_item] + '—' + _uploadObj[_item]
            _arr.push(_site)
        }
    }
    if (!_arr.length) return '未上传'
    return _arr.join('\n')
}

export function fnFormatDate(value) {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = APP.fnAddZero_public(date.getMonth() + 1);
    const day = APP.fnAddZero_public(date.getDate());
    const hours = APP.fnAddZero_public(date.getHours());
    const minutes = APP.fnAddZero_public(date.getMinutes());
    const seconds = APP.fnAddZero_public(date.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

//智能硬件 门禁设备型号提示信息
export function fnAccess(value) {
    return '门禁设备最后在线时间:' + '\n' + value;
}

// 质量/安全 巡检处理
export function fnQuality(value, limit) {
    if (!value) {
        return '';
    }
    let str = '';
    value = JSON.parse(value);
    for (let k in value) {
        let name = value[k].name ? value[k].name : value[k];
        str += (name + ',');
    }

    if (str.length > limit) {
        str = str.slice(0, limit) + '...';
    } else {
        str = str.slice(0, str.length - 1);
    }
    return str;

}

//质量/安全 巡检 title 处理
export function fnQualityTitle(value, type) {
    if (!value) {
        return '';
    }
    let str = '';
    value = JSON.parse(value);
    for (let k in value) {
        let name = value[k].name ? value[k].name : value[k];
        if (type == 1) str += 'ID:' + value[k].id + ' ' + '姓名:' + name + ',';
        else str += value[k] + ',';
    }

    str = str.slice(0, str.length - 1);

    return str;

}


// WEBPACK FOOTER //
// ./src/filters/index.js